export const DATA_TEST_ID_PREFIX = 'header-'
export const DATA_TEST_ID_PREFIX_H3_WRAPPER = 'h3-wrapper-'
export const DATA_TEST_ID_PREFIX_ICON = 'icon-'
